import { PerspectiveCamera } from "three";
import { poseFromOpenCV } from "../data/coords";
import type { SceneCamera } from "../data/types";

/**
 * Build a three.js PerspectiveCamera that matches a calibrated camera's exact
 * intrinsics + extrinsics. The 3D overlay rendered through this camera will
 * land on the same image plane as the source mp4 backdrop (modulo lens
 * distortion, which we ignore in v1).
 *
 * Caller is responsible for sizing the canvas to the camera's aspect (or
 * letterboxing) so x/y pixels line up with the backdrop.
 */
export function buildSnapCamera(cam: SceneCamera): PerspectiveCamera {
  const pc = new PerspectiveCamera(cam.fov_y_deg, cam.aspect, 0.05, 200);
  const { position, quaternion } = poseFromOpenCV(cam);
  pc.position.copy(position);
  pc.quaternion.copy(quaternion);
  pc.updateMatrixWorld(true);
  return pc;
}
